export enum ModalComponents {
  DELETE_PHOTO = 'DELETE_PHOTO',
  RESET_PASSWORD = 'RESET_PASSWORD',
  REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS',
  UPLOAD_PHOTO = 'UPLOAD_PHOTO',
  DELETE_BREWERY_PHOTO = 'DELETE_BREWERY_PHOTO',
  DELETE_PUB_PHOTO = 'DELETE_PUB_PHOTO',
  INVITE_PAGE_EDITOR = 'INVITE_PAGE_EDITOR',
  DEACTIVATE_PAGE_EDITOR = 'DEACTIVATE_PAGE_EDITOR',
  DELETE_EDITOR_PHOTO = 'DELETE_EDITOR_PHOTO',
  DELETE_USER_PHOTO = 'DELETE_USER_PHOTO',
  DELETE_BEER_PHOTO = 'DELETE_BEER_PHOTO',
  UNASSIGN_PAGE_EDITOR = 'UNASSIGN_PAGE_EDITOR',
  CHECKED_BEER_INFO = 'CHECKED_BEER_INFO',
  REMOVE_MY_LIST_BEER = 'REMOVE_MY_LIST_BEER',
  EDIT_BEER = 'EDIT_BEER',
  ADD_BEERS_ON_TAP_CONFIRMATION = 'ADD_BEERS_ON_TAP_CONFIRMATION',
  REMOVE_BEER_FROM_TAP_CONFIRMATION = 'REMOVE_BEER_FROM_TAP_CONFIRMATION',
  REMOVE_BEER_SUCCESSFULLY = 'REMOVE_BEER_SUCCESSFULLY',
  LOGOUT_CONFIRMATION = 'LOGOUT_CONFIRMATION',
  TEMPLATE_STYLE = 'TEMPLATE_STYLE',
  POST_CHANGE_BACKGROUND = 'POST_CHANGE_BACKGROUND',
  DELETE_ADMIN_BEER_CONFIRMATION = 'DELETE_ADMIN_BEER_CONFIRMATION',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  ASSIGN_PAGE_EDITOR = 'ASSIGN_PAGE_EDITOR',
  ASSIGN_PUB = 'ASSIGN_PUB',
  UNASSIGN_PUB = 'UNASSIGN_PUB',
}
